import React from 'react';
import { Chip } from '@mui/material';

const typeColorMap: Record<string, string> = {
  'Missing OTP': '#F29C38',
  'Missing Submission': '#D63964',
  'Missing Validation': '#6041B0',
  'Missing Acceptance': '#FF6300',
  'Missing Assessment': '#2BA1C6',
  'Missing Report Signature': '#67AC5B',
};

const TypeCell = React.memo((row: { type: string }) => {
  const color = typeColorMap[row.type] || '#ccc';
  return (
    <Chip
      label={row.type}
      style={{
        backgroundColor: `${color}20`, // 25% opacity in hex
        border: `1px solid ${color}`,
        boxSizing: 'border-box',
        borderRadius: 10,
        textTransform: 'none',
        height: 35,
        padding: '0 10px',
        display: 'flex',
        alignItems: 'center',
      }}
      size="small"
      variant="outlined"
    />
  );
});

export default TypeCell;
